/* NOELVA varukorgspanel: öppna/stäng, rita från /cart.js, ändra antal, ta bort, uppdatera ikonens bubbla.
   Rörelsen (0,2 s glid från höger, mörk bakgrund som tonar in) efter Shape Labs panel.
   Fraktskydd: AV som standard sedan 10 okt (Daris; 8 i varukorg men 1 till kassan när det var förvalt på). Ritas som
   vippknapp och inte som rad, räknas inte som vara. Slår kunden på det ligger det kvar under besöket. «Reserverad i» borttagen 15 okt (Daris), likaså «Fri frakt · 90 dagars garanti» i kortet (står i trygghetskortet).
   v2 15 okt (Daris: SOMNÉ:s panel): sparstapel mot paketrabatterna (data-nc-tiers, bara produkterna i data-nc-deal) + knapp
   som lägger en till av första varan, trygghetskortet och sidfoten bara när korgen har varor.
   v3 15 okt (Daris: «ändra färger för varje … som i pdp»): ETT kort per produkt med en rad per trosa (färg + storlek som
   PDP:ns blanda-läge). En ändrad rad flyttar EN trosa till den nya varianten (cart/update.js, varianterna ur /products/<handle>.js),
   så paketpriset ligger kvar. Antal +/− och papperskorgen gäller hela produkten. */
(function(){
  var root=document.querySelector('[data-nc]'); if(!root)return;
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var items=root.querySelector('[data-nc-items]'),empty=root.querySelector('[data-nc-empty]'),extra=root.querySelector('[data-nc-extra]'),foot=root.querySelector('[data-nc-foot]');
  var nudge=root.querySelector('[data-nc-nudge]'),nudgeT=root.querySelector('[data-nc-nudge-t]'),bar=root.querySelector('[data-nc-bar]'),more=root.querySelector('[data-nc-more]');
  var TIERS=(root.getAttribute('data-nc-tiers')||'').split(',').map(function(t){t=t.split(':');return {n:+t[0],kr:+t[1]};}).filter(function(t){return t.n>0;});
  var DEAL=(root.getAttribute('data-nc-deal')||'').split(',');
  var total=root.querySelector('[data-nc-total]'),save=root.querySelector('[data-nc-save]'),count=root.querySelector('[data-nc-count]');
  var checkout=root.querySelector('[data-nc-checkout]'),ctotal=root.querySelector('[data-nc-checkout-total]');
  var panel=root.querySelector('.vk__panel'),last=null,busy=false,cartNow=null,prods={},note=null;
  var FS=+root.getAttribute('data-fs-variant')||0,fsBox=root.querySelector('[data-nc-fs]'),fsIn=root.querySelector('[data-nc-fs-in]');
  function ss(k,v){try{if(v===undefined)return sessionStorage.getItem(k);if(v===null)sessionStorage.removeItem(k);else sessionStorage.setItem(k,v);}catch(e){return null;}}
  function isFs(it){return FS&&it.variant_id===FS;}

  function kr(c){var v=c/100;return (v%1===0?v.toLocaleString('sv-SE'):v.toLocaleString('sv-SE',{minimumFractionDigits:2,maximumFractionDigits:2}))+' kr';}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}
  function img(u){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width=200';}

  function bubbles(n){
    document.querySelectorAll('.lp-cart').forEach(function(a){
      var s=a.querySelector('span');
      if(n>0){if(!s){s=document.createElement('span');a.appendChild(s);}s.textContent=n;}else if(s){s.remove();}
      a.setAttribute('aria-label','Varukorg'+(n>0?', '+n+' varor':''));
    });
  }

  function render(cart){
    var fsLines=[],fsQty=0;
    cart.items.forEach(function(it,i){if(isFs(it)){fsLines.push(i+1);fsQty+=it.quantity;}});
    var n=cart.item_count-fsQty;
    count.textContent=n; bubbles(n);
    var has=n>0;
    if(fsBox){fsBox.hidden=!has;fsIn.checked=ss('nc-fs-pa')==='1';} /* kundens val, inte korgens mellanläge: annars hoppar knappen fram och tillbaka */
    syncFs(has,fsLines,fsQty);
    empty.hidden=has; extra.hidden=!has; foot.hidden=!has; checkout.disabled=!has;
    spar(cart);
    total.textContent=kr(cart.total_price); ctotal.textContent=has?kr(cart.total_price):'';
    var saved=cart.original_total_price-cart.total_price;
    save.hidden=!(saved>0); save.textContent=saved>0?'Du sparar '+kr(saved):'';
    var groups=[],byPid={};
    cart.items.forEach(function(it,i){
      if(isFs(it))return;
      var g=byPid[it.product_id];
      if(!g){g=byPid[it.product_id]={it:it,lines:[],q:0,fin:0,org:0,disc:null};groups.push(g);}
      g.lines.push({line:i+1,vid:it.variant_id,q:it.quantity,opts:(it.options_with_values||[]).map(function(o){return o.value;})});
      g.q+=it.quantity;g.fin+=it.final_line_price;g.org+=it.original_line_price;
      if(!g.disc)g.disc=((it.line_level_discount_allocations||[]).map(function(d){return d.discount_application&&d.discount_application.title;}).filter(Boolean))[0]||null;
    });
    items.innerHTML=groups.map(function(g){
      var it=g.it,pr=prods[it.handle],multi=pr&&pr.variants.length>1,was=g.org>g.fin,rows='';
      /* Raderna i produktens variantordning, så att samma färg/storlek står ihop */
      var order=pr?pr.variants.map(function(v){return v.id;}):[];
      var units=[];g.lines.slice().sort(function(x,y){return order.indexOf(x.vid)-order.indexOf(y.vid);}).forEach(function(l){for(var k=0;k<l.q;k++)units.push(l);});
      var lastVid=units.length?units[units.length-1].vid:it.variant_id;
      if(multi){
        rows='<div class="vk-units"><p class="vk-units__h">Färg och storlek för varje trosa</p>'+units.map(function(u,k){
          var v=pr.variants.filter(function(x){return x.id===u.vid;})[0]||{};
          return '<div class="vk-unit" data-vid="'+u.vid+'"><span>'+(k+1)+'</span>'+pr.options.map(function(o,oi){
            var curv=v['option'+(oi+1)];
            return '<select data-oi="'+oi+'" aria-label="'+esc(o.name)+', trosa '+(k+1)+'">'+o.values.map(function(val){return '<option'+(val===curv?' selected':'')+'>'+esc(val)+'</option>';}).join('')+'</select>';
          }).join('')+'</div>';
        }).join('')+'</div>';
      }
      var variant=!multi&&it.variant_title&&it.variant_title!=='Default Title'?it.variant_title.replace(/ \/ /g,', '):'';
      return '<div class="vk-item" data-pid="'+it.product_id+'" data-handle="'+esc(it.handle)+'" data-last="'+lastVid+'">'+
        '<a class="vk-item__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image))+'" alt="" width="80" height="80" loading="lazy">':'')+'</a>'+
        '<div class="vk-item__info">'+
          '<a class="vk-item__title" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+
          (variant?'<span class="vk-item__var">'+esc(variant)+'</span>':'')+
          '<div class="vk-item__ctrl">'+
            '<div class="vk-qty"><button type="button" data-nc-qty="-1" aria-label="Minska antal"'+(g.q<=1?' disabled':'')+'>−</button>'+
            '<span class="vk-qty__n" aria-label="Antal">'+g.q+'</span>'+
            '<button type="button" data-nc-qty="1" aria-label="Öka antal">+</button></div>'+
            '<button type="button" class="vk-item__rm" data-nc-remove aria-label="Ta bort '+esc(it.product_title)+'"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg></button>'+
          '</div>'+
          (g.disc?'<span class="vk-item__deal">'+esc(g.disc)+'</span>':'')+
        '</div>'+
        '<div class="vk-item__price"><b>'+kr(g.fin)+'</b>'+(was?'<s>'+kr(g.org)+'</s><span class="vk-item__off">−'+kr(g.org-g.fin)+'</span>':'')+'</div>'+
        rows+
        (note&&note.pid===String(it.product_id)?'<p class="vk-item__msg" role="alert">'+esc(note.t)+'</p>':'')+
      '</div>';
    }).join('');
    note=null;
  }

  /* Sparstapeln: hur många paketvaror korgen har mot nästa paket. «Billigare än nu» bara när det stämmer (3 st = 798 kr, 4 st = 499 kr). */
  function spar(cart){
    var n=0,sum=0,first=null;
    cart.items.forEach(function(it){if(isFs(it)||DEAL.indexOf(it.handle)<0)return;n+=it.quantity;sum+=it.final_line_price;if(!first)first={vid:it.variant_id,q:it.quantity};});
    nudge.hidden=!(n>0&&TIERS.length); if(nudge.hidden)return;
    var top=TIERS[TIERS.length-1],next=null;
    TIERS.forEach(function(t){if(!next&&t.n>n)next=t;});
    var t;
    if(!next)t='Du har vårt <b>bästa pris</b>: '+top.n+' för '+top.kr+' kr';
    else{
      var mer=next.kr*100-sum,diff=next.n-n,paket=next.n+' för '+next.kr+' kr';
      if(diff===1&&mer===0)t='Lägg till en till, <b>den får du gratis</b>';
      else if(mer<0)t=(diff===1?'En till':diff+' till')+' så får du <b>'+paket+'</b>, billigare än nu';
      else t='Ta '+paket+', <b>bara '+kr(mer)+' mer</b>';
    }
    nudgeT.innerHTML=t;
    bar.style.transform='scaleX('+Math.min(1,n/top.n)+')';
    root.querySelectorAll('[data-nc-dot]').forEach(function(d){d.classList.toggle('is-on',n>=+d.getAttribute('data-nc-dot'));});
    more.hidden=!next||!first;
    /* Knappen tar kunden till NÄSTA PAKET (Daris 15 okt: «varje tryck +2 som bundlesen»): 2→4→6 = +2, udda antal fylls upp (1→2, 3→4).
       De nya trosorna får samma färg/storlek som en befintlig och byts sedan rad för rad i kortet. */
    if(first&&next){var add=next.n-n,u={};u[first.vid]=first.q+add;
      more.textContent='+ Lägg till '+(add===1?'en':add)+' till';more._u=u;}
  }
  more.addEventListener('click',function(){if(more._u)upd(more._u);});

  /* Fraktskyddet: av som standard (Daris 10 okt), på bara när kunden väljer det. Högst sex misslyckade försök i rad, så att ett fel i butiken aldrig blir en loop. */
  function post(url,body){return fetch(base+url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json();});}
  function syncFs(has,lines,qty){
    if(!FS||busy)return false;
    var want=has&&ss('nc-fs-pa')==='1'?1:0;
    if(lines.length===(want?1:0)&&qty===want)return false;
    if((syncFs.n=(syncFs.n||0)+1)>6)return false;
    busy=true;
    var go=lines.length?post('cart/change.js',{line:lines[lines.length-1],quantity:want}):post('cart/add.js',{items:[{id:FS,quantity:1}]}).then(load);
    go.then(function(c){busy=false;if(c&&c.items){syncFs.n=0;show(c);}},function(){busy=false;});
    return true;
  }
  if(fsIn)fsIn.addEventListener('change',function(){
    ss('nc-fs-pa',fsIn.checked?'1':null);
    load();
  });

  /* Varianterna per produkt (för raderna) hämtas en gång per besök innan kortet ritas. */
  function show(cart){
    cartNow=cart;
    var need=[];cart.items.forEach(function(it){if(!isFs(it)&&!prods[it.handle]&&need.indexOf(it.handle)<0)need.push(it.handle);});
    return Promise.all(need.map(function(h){return fetch(base+'products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(p){if(p)prods[h]=p;}).catch(function(){});}))
      .then(function(){if(cartNow===cart)render(cart);return cart;});
  }
  function load(){return fetch(base+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(show);}
  function qtyOf(vid){var q=0;(cartNow?cartNow.items:[]).forEach(function(it){if(it.variant_id===vid)q+=it.quantity;});return q;}
  function upd(updates,el){
    if(busy)return;busy=true;root.classList.add('is-busy');if(el)el.classList.add('is-loading');
    fetch(base+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})})
      .then(function(r){if(!r.ok)throw r;return r.json();}).then(function(c){busy=false;root.classList.remove('is-busy');show(c);})
      .catch(function(){busy=false;root.classList.remove('is-busy');load();});
  }
  items.addEventListener('click',function(e){
    var card=e.target.closest('[data-pid]');if(!card)return;
    var q=e.target.closest('[data-nc-qty]'),rm=e.target.closest('[data-nc-remove]'),u={};
    if(q){var vid=+card.getAttribute('data-last');u[vid]=Math.max(0,qtyOf(vid)+(+q.getAttribute('data-nc-qty')));upd(u,card);}
    if(rm){(cartNow?cartNow.items:[]).forEach(function(it){if(String(it.product_id)===card.getAttribute('data-pid'))u[it.variant_id]=0;});
      card.classList.add('is-leaving');setTimeout(function(){upd(u);},180);}
  });
  /* En rad = en trosa: flytta EN från den gamla varianten till den nya. */
  items.addEventListener('change',function(e){
    var sel=e.target.closest('.vk-unit select');if(!sel)return;
    var row=sel.closest('.vk-unit'),card=row.closest('[data-pid]'),pr=prods[card.getAttribute('data-handle')];if(!pr)return;
    var vals=[].map.call(row.querySelectorAll('select'),function(x){return x.value;});
    var nv=pr.variants.filter(function(v){return vals.every(function(val,i){return v['option'+(i+1)]===val;});})[0];
    var old=+row.getAttribute('data-vid');
    if(!nv||!nv.available){note={pid:card.getAttribute('data-pid'),t:'Den kombinationen finns inte just nu. Välj en annan färg eller storlek.'};render(cartNow);return;}
    if(nv.id===old)return;
    var u={};u[old]=qtyOf(old)-1;u[nv.id]=qtyOf(nv.id)+1;upd(u,card);
  });

  function open(){
    last=document.activeElement;root.hidden=false;
    requestAnimationFrame(function(){requestAnimationFrame(function(){root.classList.add('is-open');});});
    document.documentElement.classList.add('vk-lock');panel.focus({preventScroll:true});load();
  }
  function close(){
    root.classList.remove('is-open');document.documentElement.classList.remove('vk-lock');
    setTimeout(function(){if(!root.classList.contains('is-open'))root.hidden=true;},220);
    if(last&&last.focus)last.focus();
  }
  checkout.addEventListener('click',function(){checkout.classList.add('is-loading');window.location.href=base+'checkout';});
  root.querySelectorAll('[data-nc-close]').forEach(function(b){b.addEventListener('click',function(e){if(b.tagName!=='A')e.preventDefault();close();});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('is-open'))close();});
  document.addEventListener('click',function(e){var a=e.target.closest('.lp-cart,[data-nc-open]');if(!a)return;e.preventDefault();open();});
  document.addEventListener('noelva:cart-open',open);
  window.NoelvaCart={open:open,close:close,refresh:load};
  if(location.hash==='#varukorg'){history.replaceState(null,'',location.pathname+location.search);open();}
})();
